var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m244.67 388.039h72.071v75.102h-72.071z",
    fill: "#a9b0bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.63 366.623h144.15c2.754 0 5 2.246 5 5v28.514c0 2.754-2.246 5-5 5h-144.15c-2.754 0-5-2.246-5-5v-28.514c.001-2.754 2.247-5 5-5z",
    fill: "#cad0d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.458 18.089 29.833 17.224c2.385 1.377 3.207 4.445 1.83 6.83l-117.023 202.692c-1.377 2.385-4.445 3.207-6.83 1.83l-29.833-17.224c-2.385-1.377-3.207-4.445-1.83-6.83l117.023-202.692c1.377-2.385 4.445-3.207 6.83-1.83z",
    fill: "#cad0d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.788 55.691 53.774 31.047c2.385 1.377 3.207 4.445 1.83 6.83l-75.411 130.616c-1.377 2.385-4.445 3.207-6.83 1.83l-53.774-31.047c-2.385-1.377-3.207-4.445-1.83-6.83l75.411-130.616c1.377-2.384 4.445-3.207 6.83-1.83z",
    fill: "#66d4f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.881 160.653-23.918-2.202-6.449 23.846c49.273 107.014 41.554 190.311-23.756 263.744l48.851 23.961 57.074-23.961c67.71-109.004 21.645-209.639-51.802-285.388z",
    fill: "#4fc0e8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 375.857,
    cy: 146.456,
    fill: "#38a8d2",
    rx: 35.938,
    ry: 35.938,
    transform: "matrix(.973 -.23 .23 .973 -23.594 90.272)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.857,
    cy: 146.456,
    fill: "#66d4f1",
    r: 11.081
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.217 446.041h267.783c2.754 0 5 2.246 5 5v39.548c0 2.754-2.246 5-5 5h-267.783c-2.754 0-5-2.246-5-5v-39.548c0-2.754 2.246-5 5-5z",
    fill: "#38a8d2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#c6ea94"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m108.146 114.753h14v242.26h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.167 229.508c-16.291-3.237-49.858-8.765-69.321-25.494-18.977-16.311-29.702-45.543-29.845-71.659-.003-.555.194-1.034.588-1.426.393-.393.872-.589 1.427-.585 26.131.189 55.662 11.849 71.657 29.842 16.341 18.384 20.3 46.114 25.494 69.322 16.291-3.237 49.858-8.765 69.322-25.494 18.977-16.311 29.702-45.543 29.844-71.659.003-.555-.194-1.034-.587-1.426-.393-.393-.872-.589-1.427-.585-26.132.189-55.662 11.849-71.657 29.842-16.344 18.384-20.302 46.113-25.495 69.322z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.798 130.526c8.243-12.172 22.772-33.646 24.281-53.627 1.571-20.796-9.271-44.331-24.534-59.889-.391-.399-.872-.6-1.43-.599s-1.039.203-1.429.602c-15.239 15.602-25.71 39.855-24.533 59.886 1.142 19.432 13.891 37.464 24.31 53.59.375.581.966.907 1.658.914.691.008 1.289-.305 1.677-.877z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m141.96 382.87 48.211 83.503c7.521 13.027-1.826 29.215-16.868 29.215h-116.274c-15.042 0-24.388-16.189-16.868-29.215l48.211-83.504c1.788-3.097 2.61-6.163 2.61-9.738v-67.651h48.369v67.652c0 3.576.822 6.641 2.609 9.738z",
    fill: "#f4f6f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.565 293.834h51.204c4.389 0 7.968 3.579 7.968 7.968v8.014c0 4.389-3.58 7.968-7.968 7.968h-51.204c-4.389 0-7.968-3.58-7.968-7.968v-8.014c-.001-4.389 3.579-7.968 7.968-7.968z",
    fill: "#e4e8eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.199 421.388c-47.357 21.207-59.255-17.415-98.064 0l-25.972 44.986c-7.521 13.027 1.826 29.215 16.868 29.215h116.274c15.042 0 24.389-16.189 16.868-29.215z",
    fill: "#fdcd56"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScience);
export default __webpack_public_path__ + "static/media/science.9bef94d32f1a1a139b026de1f3f35c99.svg";
export { ForwardRef as ReactComponent };